import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button, Table, Alert } from 'react-bootstrap';
import Select from 'react-select';
import { FaPlus, FaTrash, FaEdit } from 'react-icons/fa';
import PrisepForm from '../../../components/prisep/PrisepForm';
import {toast} from "react-toastify";

const Step3Priseps = ({ formData, updateFormData, options, setOptions }) => {
  const [selectedPrisep, setSelectedPrisep] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingPrisep, setEditingPrisep] = useState(null);
  const [errors, setErrors] = useState({});

  // Initialize selected priseps from form data
  useEffect(() => {
    // Ensure options and options.priseps are defined
    if (!options || !options.priseps) {
      setOptions(prev => ({
        ...prev,
        availablePriseps: []
      }));
      return;
    }

    if (formData.putyofka_priseps && formData.putyofka_priseps.length > 0) {
      // Filter out priseps that are already selected
      const availablePriseps = (options.priseps || []).filter(
        prisep => !formData.putyofka_priseps.some(p => p && prisep && p.id === prisep.id)
      );
      setOptions(prev => ({
        ...prev,
        availablePriseps: availablePriseps || []
      }));
    } else {
      setOptions(prev => ({
        ...prev,
        availablePriseps: [...(options.priseps || [])]
      }));
    }
  }, [formData.putyofka_priseps, options.priseps, setOptions]);

  const handleAddPrisep = React.useCallback((prisep = null) => {
    const prisepToAdd = prisep || selectedPrisep;
    
    if (!prisepToAdd) {
      setErrors(prev => ({
        ...prev,
        prisep: 'Prisepni tanlang'
      }));
      return;
    }

    // Create a new prisep object with the correct structure
    const newPrisep = {
      id: prisepToAdd.id || prisepToAdd.value,
      name: prisepToAdd.name || '',
      davlat_raqam: prisepToAdd.davlat_raqam || '',
      ...prisepToAdd
    };

    // Add to form data
    updateFormData(prev => {
      const currentPriseps = Array.isArray(prev.putyofka_priseps) ? [...prev.putyofka_priseps] : [];
      
      // Check if prisep already exists
      const isAlreadyAdded = currentPriseps.some(p => 
        p && p.id && newPrisep.id && p.id.toString() === newPrisep.id.toString()
      );
      
      if (isAlreadyAdded) {
        toast.warning('Bu prisep allaqachon qo\'shilgan');
        return prev;
      }
      
      // Add the new prisep to the list
      const updatedPriseps = [...currentPriseps, newPrisep];
      
      console.log('Adding prisep, new priseps array:', updatedPriseps);
      
      // Update available priseps in options
      setOptions(prevOptions => ({
        ...prevOptions,
        availablePriseps: (prevOptions.availablePriseps || []).filter(
          p => p && p.id && p.id.toString() !== newPrisep.id.toString()
        )
      }));
      
      // Return only the changed properties
      return {
        ...prev,
        putyofka_priseps: updatedPriseps
      };
    });

    // Reset selection if not coming from direct select
    if (!prisep) {
      setSelectedPrisep(null);
    }
    
    // Clear any errors
    setErrors(prev => ({
      ...prev,
      prisep: undefined
    }));
  }, [selectedPrisep, updateFormData]);

  const handleRemovePrisep = (prisepId) => {
    // Add back to available options
    const prisepToRemove = formData.putyofka_priseps.find(p => p.id === prisepId);
    if (prisepToRemove) {
      setOptions(prev => ({
        ...prev,
        availablePriseps: [
          ...(prev.availablePriseps || []),
          {
            id: prisepToRemove.id,
            value: prisepToRemove.id,
            label: `${prisepToRemove.name || ''} (${prisepToRemove.davlat_raqam || ''})`,
            ...prisepToRemove
          }
        ]
      }));
    }

    // Remove from form data
    updateFormData(prev => ({
      ...prev,
      putyofka_priseps: (prev.putyofka_priseps || []).filter(p => p.id !== prisepId)
    }));
  };

  const handleEditPrisep = (prisep) => {
    setEditingPrisep(prisep);
    setShowAddModal(true);
  };

  const handleSaveNewPrisep = async (newPrisep) => {
    try {
      // In a real app, you would save to the backend here
      // For now, just add to available priseps
      const newPrisepOption = {
        id: newPrisep.id,
        value: newPrisep.id,
        label: `${newPrisep.name} (${newPrisep.davlat_raqam})`,
        ...newPrisep
      };

      setOptions(prev => ({
        ...prev,
        priseps: [...prev.priseps, newPrisepOption],
        availablePriseps: [...prev.availablePriseps, newPrisepOption]
      }));

      setShowAddModal(false);
      toast.success('Prisep muvaffaqiyatli qo\'shildi');
    } catch (error) {
      console.error('Error saving prisep:', error);
      toast.error('Prisepni saqlashda xatolik yuz berdi');
    }
  };

  return (
    <div className="pw-form">
      <h5 className="mb-4">Priseps</h5>
      
      <Row className="mb-4">
        <Col md={8}>
          <Form.Group controlId="prisep">
            <Form.Label>Prisepni tanlang <span className="pw-text-danger">*</span></Form.Label>
            <div className="d-flex">
              <div className="flex-grow-1 me-2">
                <Select
                  value={selectedPrisep}
                  onChange={(selected) => {
                    setSelectedPrisep(selected);
                    if (selected) {
                      handleAddPrisep(selected);
                    }
                    if (errors.prisep) setErrors({});
                  }}
                  options={(options.availablePriseps || []).map(p => ({
                    value: p.id,
                    label: `${p.name || 'N/A'} (${p.davlat_raqam || 'N/A'})`,
                    ...p
                  }))}
                  placeholder="Prisepni tanlang..."
                  className={errors.prisep ? 'is-invalid' : ''}
                  isClearable
                />
                <Form.Text className="pw-text-danger">{errors.prisep}</Form.Text>
              </div>
            </div>
          </Form.Group>
        </Col>
        <Col md={4} className="d-flex align-items-end">
          <Button 
            variant="outline-primary" 
            onClick={() => {
              setEditingPrisep(null);
              setShowAddModal(true);
            }}
          >
            <FaPlus className="me-1" /> Yangi prisep qo'shish
          </Button>
        </Col>
      </Row>
      
      {formData.putyofka_priseps && formData.putyofka_priseps.length > 0 ? (
        <div className="pw-table-responsive">
          <Table hover className="mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Nomi</th>
                <th>Davlat raqami</th>
                <th>Harakatlar</th>
              </tr>
            </thead>
            <tbody>
              {formData.putyofka_priseps.map((prisep, index) => (
                <tr key={prisep.id}>
                  <td>{index + 1}</td>
                  <td>{prisep.name || 'N/A'}</td>
                  <td>{prisep.davlat_raqam || 'N/A'}</td>
                  <td>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleRemovePrisep(prisep.id)}
                    >
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="pw-alert pw-alert-warning">
          <i className="fas fa-exclamation-triangle me-2"></i>
          Hech qanday prisep qo'shilmagan. Iltimos, kamida bitta prisep qo'shing.
        </div>
      )}

      <div className="pw-alert pw-alert-info mt-4">
        <p className="mb-0">
          <i className="fas fa-info-circle me-2"></i>
          Agar kerakli prisep ro'yxatda bo'lmasa, "Yangi prisep qo'shish" tugmasi orqali yangi prisep qo'shishingiz mumkin.
        </p>
      </div>
      
      {/* Add/Edit Prisep Modal */}
      {showAddModal && (
        <PrisepForm
          show={showAddModal}
          onHide={() => {
            setShowAddModal(false);
            setEditingPrisep(null);
          }}
          onSave={handleSaveNewPrisep}
          prisep={editingPrisep}
        />
      )}
    </div>
  );
};

export default Step3Priseps;
